<div class="grid min-height">
   <div class="col-fixed flex flex-column gap-3 bg-bluegray-50 py-4 px-3" style="min-width: 250px">
      <p-button
         [text]="true"
         [plain]="true"
         *ngFor="let filter of filters"
         class="filter-list-item"
         (click)="selectFilter(filter)"
      >
         <div
            class="flex flex-row gap-2 align-items-center"
            [ngClass]="{
               'font-semibold': isFilterApplied(filter)
            }"
         >
            <i [class]="filter?.icon || ''" [ngClass]="{ 'text-blue-600': selectedFilterId === filter.id }"> </i>
            <span
               class="filter-name text-overflow-ellipsis font-medium text-700"
               [ngClass]="{ 'text-blue-600 font-semibold': selectedFilterId === filter.id }"
               >{{ filter.label }}</span
            >
            <i
               class="pi pi-angle-right"
               [ngClass]="{ 'text-blue-600': selectedFilterId === filter.id }"
               *ngIf="selectedFilterId === filter.id"
            ></i>
         </div>
      </p-button>

      <p-button
         [severity]="'primary'"
         [label]="'DATA.COMMON.ACTIONS.APPLY_FILTERS' | translate"
         (onClick)="search()"
         styleClass="w-full"
         icon="pi pi-search"
         class="align-items-center"
      ></p-button>
   </div>

   <div class="col flex flex-row bg-white min-width-item" style="max-width: 1000px; min-width: 350px">
      <ng-container *ngIf="selectedFilterIdChanged && itCloses; else placeholder">
         <app-filter-item
            class="w-full"
            [selectedFilter]="selectedFilter!"
            [selectedFilterId]="selectedFilterIdChanged || filterService.getDefaultFilters()[0].filter.id"
            (valueChange)="onFilterChange($event)"
         ></app-filter-item>
      </ng-container>

      <ng-template #placeholder>
         <!-- This content shows during the brief null state -->
         <div class="w-full" style="min-height: 50px"></div>
      </ng-template>
   </div>
</div>
